























































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DistrictSearch from '@/app/components/District/DistrictSearch.vue'
import DistrictList from '@/app/components/District/DistrictList.vue'
/* api */
import DistrictListApi from '@/app/model/api/districtListApi'
/* module */
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    DistrictSearch,
    DistrictList
  }
})
export default class DistrictMaster extends Vue {
  /* データ */
  private districtData: any = {}
  private sort: string = ''
  private totalCount: number = 0
  private alertText: string = ''
  /* 表示非表示 */
  private notDataMessage: boolean = false
  private showServerErrorModal: boolean = false
  private showAreaAlert: boolean = false
  private showLoading: boolean = true

  created () {
    this.getDistrictList('')
  }

  /* 初期表示&検索&ソート */
  private getDistrictList (sortName: string) {
    (async () => {
      this.showLoading = true

      /* state保持 */
      if (sortName !== '') {
        if (this.$store.state.districtState.sortAsc) {
          this.$store.commit('districtState/setSortAsc', false)
        } else {
          this.$store.commit('districtState/setSortAsc', true)
        }
      }
      if (sortName !== this.$store.state.districtState.sortName && sortName !== '') {
        this.$store.commit('districtState/setSortName', sortName)
        this.$store.commit('districtState/setSortAsc', true)
      }

      if (this.$store.state.districtState.sortAsc) {
        this.sort = 'asc'
      } else {
        this.sort = 'desc'
      }

      const data : any = {
        sortName: this.$store.state.districtState.sortName,
        sort: this.sort,
        text: this.$store.state.districtState.searchText
      }

      const result = await DistrictListApi.getDistrictList(data)

      if (result.isOk()) {
        this.updateList(result.getPayload().results)
        this.districtData = result.getPayload().results
        this.totalCount = result.getPayload().result_count
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private updateList (val: any) {
    this.$store.commit('districtState/setDistrictList', val)
    this.districtData = this.$store.state.districtState.districtData

    if (this.districtData.length === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }
  }

  private showAlert () {
    this.showAreaAlert = true
  }

  private logout () {
    CommonClass.doLogout()
  }

  private closeAreaAlert () {
    this.showAreaAlert = false
  }
}
